import cx from "classnames";

// CSS
import styles from "./search.module.scss";

const Search = (props) => {
    const { classes, isLight, onChange, onSubmit } = props;

    return (
        <div
            className={cx(styles.search, classes, {
                [styles["search--light"]]: isLight,
            })}
        >
            <form onSubmit={onSubmit}>
                <input
                    className={styles.input}
                    onChange={onChange}
                    type="text"
                />
                <span
                    className={cx(
                        styles.icon,
                        `material-icons material-icons-outlined`
                    )}
                    onClick={onSubmit}
                >
                    search
                </span>
            </form>
        </div>
    );
};

export default Search;
